import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'

import GoogleMap from 'google-map-react';
import config from 'react-global-configuration';
import { SectionText } from '../marketing/MarketingStyles'

class GolfCourseMarker extends Component {

  constructor(props) {
    super(props)
  }

  render() {

    const open = this.props.selected
    const data = this.props.data

    const Pointer = this.props.pointer
    const Icon = this.props.icon

    return (
      <MarkerWrapper onClick={ () => open ? this.props.deselectCourse() : this.props.selectCourse() } open={open}>
        { open &&
          <MarkerPopup>
            <PopupContent>
              <PopupTitle>{ data.title }</PopupTitle>
              <PopupText>{ data.type.infoText }</PopupText>
              <PopupText> in { data.location }</PopupText>
            </PopupContent>
          </MarkerPopup>
        }

        { open &&
          <MarkerIndicatorWrapper>
            <Icon />
          </MarkerIndicatorWrapper>
        }
        { !open &&
          <MarkerPointerWrapper>
            <Pointer size="100%" />
          </MarkerPointerWrapper>
        }
      </MarkerWrapper>
    )
  }
}

export default GolfCourseMarker

const MarkerWrapper = styled.div `
  width: 20px;
  height: 20px;
  position: relative;
  z-index: ${props => props.open ? 101 : 100};
  cursor: pointer;
  transform: translateY(-35px);
`

const MarkerPopup = styled.div `
  background: white;
  position: absolute;
  bottom: calc( 100% );
  left: 10px;
  transform: translateX( -50% );
  width: 200px;
  border-radius: 20px;
  z-index: 101;
  overflow: hidden;
  text-align: center;
`

const PopupImage = styled.img `
  width: 100%;
  height: 100px;
`

const PopupContent = styled.div `
  padding: 10px;
`

const PopupTitle = styled.div `
  font-family: 'Supreme-Medium';
  font-size: 12px;
  letter-spacing: 0.02em;
  color: black;
  padding-bottom: 5px;
  border-bottom: 1px solid black;
  margin-bottom: 5px;
`

const PopupText = styled.div `
  font-family: 'Supreme-Regular';
  font-size: 12px;
  letter-spacing: 0.03em;
  color: #000000BB;
  padding: 5px 0;
`

const MarkerPointerWrapper = styled.div `
  position: absolute;
  top: -5px;
  left: -5px;
  width: 30px;
  filter: drop-shadow(0px 5px 20px rgba(47, 67, 97, 0.3));

  > div {
    width: 100%
  }
`

const MarkerIndicatorWrapper = styled.div `
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 0 0 50% 50%;
  top: -5px;
  left: -5px;
  background: white;

  ::before {
    content: '';
    position: absolute;
    left: -5px;
    top: 5px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 5px 5px 0;
    border-color: transparent #ffffff transparent transparent;
  }
  ::after {
    content: '';
    position: absolute;
    right: -5px;
    top: 5px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 5px 0 0;
    border-color: #ffffff transparent transparent transparent;
  }
`



// WEBPACK FOOTER //
// /src/components/admin/OverviewMapMarker.js